
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gta7bmwxR3piPnHB1eUYEybowiiKAWpHCPxkLrYD9jkQMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index6RHT4FNtjvXbg92eznrEYzf_45mMhlvMvFa7tr8ODg5yoMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchIr9bTEg_45pNGHu8bhq1knTv4ZX3aFNI92cE_ySSsoo3cMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexLDodlqOJEzY_450AH_oNyfEnBBUtd2rHpRL32lJFaW_45I4Meta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bSNRW6_zxq081S0ioHLTwJ_XuWPoivin_RGk9rPahSsMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexqxBJ7YXMv8m5ghQq1oufrZQcdtbIelOfWY1rFoviHM0Meta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93aY6Zb5t4oGlZGX0CJ1l_45R5X0rcOwUTpk5fa4Vwugv9oMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexS44nWuJpjpzyUVMywZqhy6HndOR6ebSimISHKiVJjFsMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ip0xt7a85XZkIJuHzyuqwJM93g_45elKT_TvgCBtny0FYMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexn3nD_45GBcndKZcZmdUgo399Jod9LLHx4Q1H7BK0W1QdgMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexf83YXxebtdeRPKwzA_45e3fIJnO2OUxpfoU501iq8CweoMeta } from "/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexqxBJ7YXMv8m5ghQq1oufrZQcdtbIelOfWY1rFoviHM0Meta || {},
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexS44nWuJpjpzyUVMywZqhy6HndOR6ebSimISHKiVJjFsMeta || {},
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexn3nD_45GBcndKZcZmdUgo399Jod9LLHx4Q1H7BK0W1QdgMeta || {},
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexf83YXxebtdeRPKwzA_45e3fIJnO2OUxpfoU501iq8CweoMeta || {},
    component: () => import("/codebuild/output/src2004508490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]